import { Splide } from "@splidejs/splide";
import "@splidejs/splide/css/core";

window.addEventListener("DOMContentLoaded", (event) => {
  const sliderContainers = document.querySelectorAll(".with-posts");

  if (sliderContainers) {
    sliderContainers.forEach((container) => {
      const slider = new Splide(container, {
        focus: "center",
        type: "loop",
        padding: "195px",
        arrows: false,
        perPage: 3,
        breakpoints: {
          1700: {
            padding: "100px",
          },
          1470: {
            padding: "50px",
          },
          1200: {
            perPage: 2,
          },
          992: {
            perPage: 1,
            padding: "200px",
          },
          768: {
            padding: "120px",
          },
          576: {
            padding: "20px",
          },
        },
      });

      slider.on("mounted", function () {
        lazy?.update();
      });

      slider.mount();
    });
  }

  const sliderWithCoaches = document.querySelectorAll(
    ".coaches-slider .splide"
  );
  if (sliderWithCoaches) {
    sliderWithCoaches.forEach((container) => {
      new Splide(container, {
        perPage: 4,
        perMove: 1,
        autoplay: true,
        type: "loop",
        arrows: false,
        gap: "110px",
        breakpoints: {
          1470: {
            perPage: 3,
          },
          1200: {
            gap: "50px",
          },
          768: {
            perPage: 2,
          },
          400: {
            gap: "20px",
          },
        },
      }).mount();
    });
  }

  const sliderWithCircles = document.querySelectorAll(".posts-with-circles");
  if (sliderWithCircles) {
    sliderWithCircles.forEach((container) => {
      new Splide(container, {
        autoWidth: true,
        perMove: 1,
        type: "loop",
        arrows: false,
        gap: "60px",
        focus: "center",
      }).mount();
    });
  }

  const firstSection = document.querySelector("#main section:nth-child(3)");
  if (firstSection) {
    firstSection.classList.add("first-section");
  }

  const scrollDown = document.querySelector(".scroll-down");
  if (scrollDown) {
    scrollDown.addEventListener("click", (event) => {
      event.preventDefault();
      const target = document.querySelector(".first-section");
      const rect = target.getBoundingClientRect();
      const header = document.querySelector("#header");
      const headerHeight = header.offsetHeight;
      const top = rect.top + window.scrollY - headerHeight;
      window.scrollTo({
        top: top,
        behavior: "smooth",
      });
    });
  }
});
